import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { usePmsDepartmentType, PmsDepartmentType } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => (
  <GenericFormPage<PmsDepartmentType>
    useData={usePmsDepartmentType}
    config={{
      ...moduleConfig,
      getInitialFormData,
      mapItemToFormData,
    }}
  />
);

export default Form;
